import styleToJS from 'style-to-js'

function cssToJs(style?: string | null) {
  try {
    return styleToJS(style ?? '', { reactCompat: true })
  } catch {
    // eslint-disable-next-line no-console
    console.warn('Could not parse style.', { style })
    return {}
  }
}

export default cssToJs
